module.exports = __webpack_public_path__ + "static/media/clothes-7.b6cd3299.jpg";